<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->

<template>
	<div>
		<BRow>
			<BCol class="error-notification-col">
				<div class="error-notification">
					<h2>We couldn't find that Web page (Error 404)</h2>
					<p>
						We're sorry you ended up here. Sometimes a page gets moved or deleted, but hopefully we can help you
						find what you're looking for.
					</p>
					<ul>
						<li>
							Return to the
							<router-link
								class="notifLink"
								:to="{ path: '/' }"
								:data-test-automation-id="getAutomationId('messageLinkEn')"
								>Home Page
							</router-link>
						</li>
					</ul>
				</div>
				<div class="medavieLogo justify-content-end">
					<img
						:id="getUniqueId('enLogo')"
						src="@/assets/Med-Eng.jpg"
						alt="Medavie Blue Cross"
						data-test-automation-id="footerEnLogo"
					/>
				</div>
			</BCol>
			<BCol class="error-notification-col">
				<div class="error-notification">
					<h2>Nous ne pouvons trouver cette page Web (Erreur 404)</h2>
					<p>
						Nous sommes désolés que vous ayez abouti ici. Il arrive parfois qu’une page ait été déplacée ou
						supprimée. Heureusement, nous pouvons vous aider à trouver ce que vous cherchez.
					</p>
					<ul>
						<li>
							Retournez à la
							<router-link
								class="notifLink"
								:to="{ path: '/' }"
								:data-test-automation-id="getAutomationId('messageLinkFr')"
								>page d’accueil
							</router-link>
						</li>
					</ul>
				</div>
				<div class="medavieLogo justify-content-end">
					<img
						:id="getUniqueId('frLogo')"
						src="@/assets/Med-Fre.jpg"
						alt="Croix Bleue Medavie"
						data-test-automation-id="footerFrLogo"
					/>
				</div>
			</BCol>
		</BRow>
		<!-- <BRow>
			<BCol class="medavieLogo justify-content-end">
				<img
					:id="getUniqueId('enLogo')"
					src="@/assets/Med-Eng.jpg"
					alt="Medavie Blue Cross"
					data-test-automation-id="footerEnLogo"
				/>
			</BCol>
			<BCol class="medavieLogo justify-content-end">
				<img
					:id="getUniqueId('frLogo')"
					src="@/assets/Med-Fre.jpg"
					alt="Croix Bleue Medavie"
					data-test-automation-id="footerFrLogo"
				/>
			</BCol>
		</BRow> -->
	</div>
</template>
<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';

@Component({
	name: 'PageNotFoundNoLocale',
	components: {},
	props: {
		automationId: {
			type: String,
			required: true
		}
	},
	mixins: [IdMixin]
})
export default class PageNotFoundNoLocale extends Vue {}
</script>
<style lang="scss" @scoped>
.notifLink,
.notifLink:hover {
	text-align: left;
	text-decoration: underline;
	font: normal normal bold 20px/26px Noto Sans;
	letter-spacing: 0px;
	color: #295376;
}

.error-notification-col {
	margin-top: 5%;
	margin-left: 5%;
	margin-right: 5%;
	background: #ffffff 0% 0% no-repeat padding-box;
	border-image: linear-gradient(to bottom, #d3080c 16px, #d3080c 16px, transparent 16px, transparent 48px, #d3080c 48px, #d3080c 48px) 1 100%;
	border-left: 6px solid #000;
	border-radius: 0;
	border-style: solid;
	border-width: 0 0 0 4px;
	min-height: 118px;
	padding-left: 1%;
	display: grid;
}

.error-notification {
	h2 {
		text-align: left;
		font: normal normal bold 26px/32px Lato;
		letter-spacing: 0px;
		padding-left: 35px;
		padding-top: 20px;
		color: #000000;
		opacity: 1;
	}
	p,
	ul {
		text-align: left;
		font: normal normal normal 20px/26px Noto Sans;
		letter-spacing: 0px;
		padding-left: 35px;
		color: #000000;
		opacity: 1;
	}

	ul {
		list-style-position: inside;
	}
}

.error-notification::before {
	font-family: 'Glyphicons Halflings';
	font-size: 26px;
	line-height: 2.3em;
	padding: 5px;
	position: absolute;
	color: #d40811;
	content: url('../assets/error.png');
	@media (min-width: 460px) {
		margin-left: -1.16em;
	}
	@media (max-width: 460px) {
		margin-left: -0.9em;
	}
}

.medavieLogo {
	text-align: right;
	padding: 2% 7%;
	img {
		max-width: 100%;
		height: 36px;
	}
	@media (min-width: 460px) {
		position: absolute;
		bottom: -60px;
		right: 0;
	}
}
</style>
